import { START_PAGE } from "../../utils/Constant";
import {  GET_ALL_TOOLS_DATA } from "./ActionTypes";

export const getAllToolsData = (payload, currentPage = START_PAGE) => ({
    type: GET_ALL_TOOLS_DATA,
    payload,
    currentPage,
});